import { useContext } from 'react';
import { OnStartWarningHook } from '../../../../_Common/Const/Rutiner';
import AnvandarInstallningarQuery from '../Queries/FarHanteraBokforderQuery.gql';
import {
  FarHanteraBokforderQuery,
  FarHanteraBokforderQueryVariables,
} from '../Queries/_QueryTypes/FarHanteraBokforderQuery';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export const useBokforderOnStartWarningHook: OnStartWarningHook =
  isLoggedIn => {
    const activeDatabase = useContext(ActiveDatabaseContext);
    const { data, loading } = useQuery<
      FarHanteraBokforderQuery,
      FarHanteraBokforderQueryVariables
    >(AnvandarInstallningarQuery, {
      fetchPolicy: 'cache-and-network',
      variables: {
        dbname: activeDatabase.activeDatabase || '',
      },
      skip: !activeDatabase.activeDatabase || !isLoggedIn,
    });

    return {
      loading: loading,
      ok: !loading && Boolean(data?.me?.[0]?.farHanteraBokforder?.result),
      warningText: data?.me?.[0]?.farHanteraBokforder?.message || '',
    };
  };
